import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import EditTeam from "../EditTeam";

export const EditTeamModal = (props) => {
  const { isOpen, setIsOpen, team } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      size={"2xl"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Team</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <EditTeam
            onSuccess={() => {
              setIsOpen(false);
            }}
            team={team}
          />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
